export default "__VITE_ASSET__3913426d__"